export default "/_next/static/images/Soho-e4a6598a0a7e691107e11c74d8d52818.png";